import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Accueil from './pages/Accueil';
import Histoire from './pages/Histoire';
import Spiritualite from './pages/Spiritualite';
import Lieux from './pages/Lieux';
import Actualites from './pages/Actualites';
import ActualiteDetail from './pages/ActualiteDetail';
import Contact from './pages/Contact';
import ProgrammeNiane from './pages/ProgrammeNiane';
import BibliothequeNumerique from './pages/BibliothequeNumerique';
import Evenements from './pages/Evenements';
import TourismeReligieux from './pages/TourismeReligieux';
import TourismeCulturel from './pages/TourismeCulturel';
import Annuaire from './pages/Annuaire';
import Connexion from './pages/Connexion';
import Inscription from './pages/Inscription';
import Profil from './pages/Profil';
import Signaler from './pages/Signaler';

// Admin
import AdminRoute from './admin/AdminRoute';
import AdminLayout from './admin/AdminLayout';
import Dashboard from './admin/pages/Dashboard';
import AdminActualites from './admin/pages/Actualites';
import AdminAnnuaire from './admin/pages/Annuaire';
import AdminArchives from './admin/pages/Archives';
import AdminChantiers from './admin/pages/Chantiers';
import AdminConseil from './admin/pages/Conseil';
import AdminGalerie from './admin/pages/Galerie';
import AdminMembres from './admin/pages/Membres';
import AdminModeration from './admin/pages/Moderation';
import AdminNewsletter from './admin/pages/Newsletter';
import AdminSignalements from './admin/pages/Signalements';
import AdminStatistiques from './admin/pages/Statistiques';
import AdminTalents from './admin/pages/Talents';
import AdminTourisme from './admin/pages/Tourisme';
import AdminAgenda from './admin/pages/Agenda';
import AdminSeances from './admin/pages/Seances';
import AdminCaisse from './admin/pages/Caisse';

// Public — séances & PV du conseil
import Seances from './pages/Seances';
import SeanceDetail from './pages/SeanceDetail';

// Public — tourisme (sites + circuits depuis l'API)
import SiteDetail from './pages/SiteDetail';
import CircuitDetail from './pages/CircuitDetail';

// Public — caisse du village (campagnes + cotisations)
import Caisse from './pages/Caisse';

// Layout public : Header + page + Footer
const PublicLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
  </>
);

// Layout auth : sans Header/Footer (immersif)
const AuthLayout = () => <Outlet />;

function App() {
  return (
    <Router>
      <Routes>
        {/* ---------- Routes publiques (avec Header/Footer) ---------- */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Accueil />} />
          <Route path="/histoire" element={<Histoire />} />
          <Route path="/spiritualite" element={<Spiritualite />} />
          <Route path="/tourisme" element={<TourismeReligieux />} />
          <Route path="/talents" element={<TourismeCulturel />} />
          <Route path="/asc" element={<Evenements />} />
          <Route path="/actualites" element={<Actualites />} />
          <Route path="/actualites/:slug" element={<ActualiteDetail />} />
          <Route path="/mairie" element={<Contact />} />
          <Route path="/galerie" element={<Lieux />} />
          <Route path="/annuaire" element={<Annuaire />} />
          <Route path="/bibliotheque" element={<BibliothequeNumerique />} />
          <Route path="/programme-niane" element={<ProgrammeNiane />} />
          <Route path="/profil" element={<Profil />} />
          <Route path="/signaler" element={<Signaler />} />
          <Route path="/seances" element={<Seances />} />
          <Route path="/seances/:id" element={<SeanceDetail />} />
          <Route path="/tourisme/circuit/:slug" element={<CircuitDetail />} />
          <Route path="/tourisme/:slug" element={<SiteDetail />} />
          <Route path="/caisse" element={<Caisse />} />

          {/* Alias rétro-compat */}
          <Route path="/tourisme-religieux" element={<Navigate to="/tourisme" replace />} />
          <Route path="/tourisme-culturel" element={<Navigate to="/talents" replace />} />
          <Route path="/evenements" element={<Navigate to="/asc" replace />} />
          <Route path="/contact" element={<Navigate to="/mairie" replace />} />
          <Route path="/lieux" element={<Navigate to="/galerie" replace />} />
        </Route>

        {/* ---------- Routes auth (sans header/footer) ---------- */}
        <Route element={<AuthLayout />}>
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/login" element={<Navigate to="/connexion" replace />} />
          <Route path="/register" element={<Navigate to="/inscription" replace />} />
        </Route>

        {/* ---------- Routes admin (protégées) ---------- */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard"    element={<Dashboard />} />
          <Route path="moderation"   element={<AdminModeration />} />
          <Route path="statistiques" element={<AdminStatistiques />} />
          <Route path="actualites"   element={<AdminActualites />} />
          <Route path="archives"     element={<AdminArchives />} />
          <Route path="galerie"      element={<AdminGalerie />} />
          <Route path="tourisme"     element={<AdminTourisme />} />
          <Route path="membres"      element={<AdminMembres />} />
          <Route path="talents"      element={<AdminTalents />} />
          <Route path="annuaire"     element={<AdminAnnuaire />} />
          <Route path="chantiers"    element={<AdminChantiers />} />
          <Route path="conseil"      element={<AdminConseil />} />
          <Route path="seances"      element={<AdminSeances />} />
          <Route path="caisse"       element={<AdminCaisse />} />
          <Route path="agenda"       element={<AdminAgenda />} />
          <Route path="signalements" element={<AdminSignalements />} />
          <Route path="newsletter"   element={<AdminNewsletter />} />
        </Route>

        {/* 404 → accueil */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
